import React from 'react'
import { Container } from '../../utils'
import BannerBackground from 'assets/icons/svg/coronavirus-cta-bkgd.svg'

const CoronaVirusIdentityBanner = ({ title }) => {
  return (
    <header className="relative py-8 mb-6 md:py-10 bg-gradient-coronavirus">
      <Container>
        <div className="flex">
          <div>
            <span className="block text-lg font-semibold text-white md:text-2xl md:font-medium">
              Coronavirus/Covid 19
            </span>
            <h1 className="text-3xl font-semibold text-white md:text-4xl lg:text-4xl">
              {title}
            </h1>
          </div>
        </div>
      </Container>
      <div className="absolute z-0 flex justify-end h-full overflow-hidden opacity-10 md:w-full pin-t pin-r pin-b">
        <img
          src={BannerBackground}
          alt="Coronavirus Title Icon"
          className="w-1/2 sm:w-auto"
        />
      </div>
    </header>
  )
}

export default CoronaVirusIdentityBanner
